import { useContext } from "react";
import Loading from "../../components/basics/Loading";
import HeaderModule from "../../components/header/HeaderModule";
import TableEmails from "./children/TableEmails";
import {
  TemplateEmailsContext,
  TemplateEmailsContextProvider,
} from "./contexts/TemplateEmailsContext";

function View({ location }) {
  const { mainLoading } = useContext(TemplateEmailsContext);
  return (
    <>
      <Loading open={mainLoading} />
      <HeaderModule title="TEMPLATES DE EMAILS" />
      <TableEmails />
    </>
  );
}

const EmailsList = ({ ...props }) => (
  <TemplateEmailsContextProvider>
    <View {...props} />
  </TemplateEmailsContextProvider>
);

export default EmailsList;
